import Check from '@mui/icons-material/Check';
import { Box, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

const LoadingContainer = styled(Box)(() => ({
  position: 'absolute',
  zIndex: 20,
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  top: '0px',
  left: '0px',
  '&:before': {
    content: '""',
    zIndex: -1,
    position: 'absolute',
    height: '100%',
    width: '100%',
    background: 'white',
    opacity: 0.8,
  },
}));

interface OwnProps {
  isSuccess?: boolean;
  successComponent?: React.ReactNode;
  background?: string;
  position?: string;
}
const LoadingCover = (props: OwnProps) => {
  const { successComponent = null, background } = props;
  return (
    <LoadingContainer sx={{ background }}>
      {props.isSuccess ? (
        successComponent ? (
          successComponent
        ) : (
          <Check
            color="primary"
            sx={{ fontSize: '40px' }}
            data-cy="loading-success"
          />
        )
      ) : (
        <CircularProgress />
      )}
    </LoadingContainer>
  );
};

export default LoadingCover;
